var map = {
	"./music-instructions.json": 4305,
	"./music-library-intro2024.json": 4306,
	"./music-library-launch2024.json": 4307,
	"./music-progression.json": 4308,
	"./startSourcesAdvanced.json": 4309,
	"./startSourcesSimple.json": 4310,
	"./startSourcesSimple2.json": 4311,
	"./startSourcesTracks.json": 4312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4041;